import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTitle: React.FC = () => {
  const location = useLocation();
  
  // Map routes to page titles
  const getPageTitle = (pathname: string): string => {
    const baseTitle = "GACPoint";
    
    // Check for /requests/:id route
    if (pathname.startsWith("/requests/")) {
      const requestId = pathname.split("/")[2];
      return `Request ${requestId} - GACPoint`;
    }
    
    // Remove leading slash and split path
    const path = pathname.replace(/^\//, "").split("/")[0];
    
    const titleMap: { [key: string]: string } = {
      "": "GACPoint",
      "auth": "Sign In - GACPoint",
      "access-management-dashboard": "Platforms - GACPoint",
      "dashboard": "Platforms - GACPoint",
      "access-request-queue": "Access Request Queue - GACPoint",
      "check-platform-access": "Check Platform Access - GACPoint",
      "check-snowflake-access": "Check Platform Access - GACPoint",
      "security-groups": "Security Groups - GACPoint",
      "securable-owner": "Securable Owner - GACPoint",
      "account-owner": "Account Owner - GACPoint",
      "settings": "Settings - GACPoint",
      "profile": "Profile - GACPoint",
    };
    
    return titleMap[path] || `${baseTitle} - ${path.charAt(0).toUpperCase() + path.slice(1)}`;
  };
  
  useEffect(() => {
    const title = getPageTitle(location.pathname);
    document.title = title;
  }, [location.pathname]);
  
  return null;
};

export default PageTitle;

